export enum SetbackType {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
};
